import { MasonryGrid } from "@egjs/grid";
import { checkOnScreenEls } from '../../../../assets/src/js/common/on-screen';

import '../sass/jbanks-collection-gallery.scss';

(() => {
    const $jbanksCollectionGalleries = document.querySelectorAll('.jbanks-collection-gallery');

    if (!$jbanksCollectionGalleries) return;

    $jbanksCollectionGalleries.forEach($jbanksCollectionGallery => {
        const $grid = $jbanksCollectionGallery.querySelector('.jbanks-collection-gallery__grid');
        
        const initImagesGrid = () => {
            const grid = new MasonryGrid($grid, {
                align: 'start',
            });

            grid.renderItems();
        };

        initImagesGrid();
    });
})();
